/**
 * converts spaces to dashes and lowercases the string
 * @param str
 * @returns hyphenLowerCase("test Item") === "test-item"
 */
export var hyphenLowerCase = function (str) {
    return str.replace(/\s+/g, "-").toLowerCase();
};
